import React from 'react';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';
import { SECFiling } from '../types';
import { Tooltip } from '@mui/material';

interface FilingTableProps {
  filings: (SECFiling & { id: string })[];
}

const columns: GridColDef[] = [
  { 
    field: 'name', 
    headerName: 'Name', 
    flex: 2,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {params.value}
        </div>
      </Tooltip>
    )
  },
  { 
    field: 'formType', 
    headerName: 'Form Type', 
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {params.value}
        </div>
      </Tooltip>
    )
  },
  { 
    field: 'ownership', 
    headerName: 'Ownership', 
    flex: 0.8,
    minWidth: 100
  },
  {
    field: 'timestamp',
    headerName: 'Timestamp',
    flex: 1.2,
    minWidth: 160,
    valueFormatter: ({ value }) => {
      if (!value) return '';
      try {
        return new Date(value).toLocaleString();
      } catch {
        return 'Invalid Date';
      }
    },
  },
  {
    field: 'filingDate',
    headerName: 'Filing Date',
    flex: 0.8,
    minWidth: 100,
    valueFormatter: ({ value }) => {
      if (!value) return '';
      try {
        return new Date(value).toLocaleDateString();
      } catch {
        return 'Invalid Date';
      }
    },
  },
  { 
    field: 'cik', 
    headerName: 'CIK', 
    flex: 0.7,
    minWidth: 90
  },
  {
    field: 'link',
    headerName: 'View Filing',
    flex: 0.6,
    minWidth: 80,
    renderCell: ({ value }) => (
      value ? <a href={value} target="_blank" rel="noopener noreferrer">View</a> : ''
    ),
  },
];

export const FilingTable: React.FC<FilingTableProps> = ({ filings }) => {
  return (
    <div style={{ height: 'calc(100vh - 100px)', width: '100%' }}>
      <DataGrid
        rows={filings}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 25,
            },
          },
          sorting: {
            sortModel: [{ field: 'timestamp', sort: 'desc' }],
          },
        }}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 300 },
          },
        }}
        pageSizeOptions={[25]}
        disableRowSelectionOnClick
        autoHeight={false}
        density="compact"
      />
    </div>
  );
};
